import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'baseIsEmpty', pure: true })
export class BaseIsEmptyPipe implements PipeTransform {
  transform(value: unknown, replaceText: string = '-'): string {
    if (value === null || value === undefined) {
      return replaceText;
    }

    if (typeof value === 'string') {
      const trimmed = value.trim();
      return trimmed.length === 0 ? replaceText : trimmed;
    }

    return String(value);
  }
}
